import { getAspectRatioStyle } from "@common/controls/AspectRatioContainer/lib";
import classnames from "classnames";
import * as React from "react";
import { type VideoProps } from "../component";
import { getAllow } from "../lib";
import { getSrc } from "./lib";

export type VimeoVideoProps = VideoProps & {
  allowFullScreen?: boolean;

  videoId?: string;
};

const VimeoVideo = (props: VimeoVideoProps) => (
  <div
    className={classnames("video_container", { background: props.isBackground })}
    style={getAspectRatioStyle(props.aspectRatio)}
  >
    <div className="video vimeo_video">
      <iframe
        allowFullScreen={props.allowFullScreen}
        allow={getAllow({
          ...props,
          allowFullScreen: false
        })}
        height="100%"
        width="100%"
        src={getSrc(props)}
      />

      {props.isBackground && <div className="overlay" />}
    </div>
  </div>
);

export default VimeoVideo;
